import { CKButton } from '@clearkit/react';
import { Link } from 'react-router-dom';

import styles from './styles';
import SuccessIcon from './Success.svg';

function UpgradeAccountComplete({ classes, email, backPath }) {
  return (
    <div className={classes.body}>
      <div className={classes.confirmationContentBox}>
        <div className={classes.confirmationHeader}>
          <div className="inline-block mb-3">
            <SuccessIcon className="display-inline" />
          </div>
          <h1>Thanks for contacting our success team</h1>
          <p>
            Our team will be reaching out to you at <span>{email}</span> as soon
            as possible with information on upgrading your Clearbit plan
          </p>
        </div>

        <div className={classes.confirmationFooter}>
          <CKButton
            className={classes.cancelButton}
            as={Link}
            to={backPath}
            variant="secondary">
            Dismiss
          </CKButton>
        </div>
      </div>
    </div>
  );
}

UpgradeAccountComplete.propTypes = {
  classes: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired,
  backPath: PropTypes.string,
};

export default withStyles(styles)(UpgradeAccountComplete);
